<template>
  <div>
    <template v-if="employmentPoliciesReport">
      <template v-if="chartData.type == 'Table'">
        <b-row v-for="(chartData, key) in charts" :key="key">
          <b-col>
            <card-chart-indicator
              :chart-data="chartData"
              :alias="alias + key"
              :height="height"
            />
          </b-col>
        </b-row>
      </template>
    </template>
    <template v-else>
      <template v-if="singleChart">
        <template v-if="key < maxCharts">
          <b-row v-for="(chartData, key) in charts" :key="key">
            <b-col>
              <card-chart-indicator
                :chart-data="chartData"
                :alias="alias + key"
                :height="height"
              />
            </b-col>
          </b-row>
        </template>
      </template>
      <template v-else>
        <template v-if="firstChart <= key && key < maxCharts + firstChart">
          <b-row v-for="(chartData, key) in charts" :key="key">
            <b-col>
              <card-chart-indicator
                :chart-data="chartData"
                :alias="alias + key"
                :height="height"
              />
            </b-col>
          </b-row>
        </template>
      </template>
    </template>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "CardChartsIndicatorConsolidated",
  props: {
    pillarId: {
      default: "",
    },
    indicatorId: {
      default: "",
    },
    alias: {
      default: "",
    },
    height: {
      type: String,
      default: "auto",
    },
    maxCharts: {
      type: Number,
      default: 1000,
    },
    firstChart: {
      type: Number,
      default: 1000,
    },
    singleChart: {
      type: Boolean,
      default: true,
    },
    employmentPoliciesReport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      indicator: {},
      charts: [],
    };
  },
  watch: {
    indicatorId: function () {
      this.updateData();
    },
  },
  methods: {
    updateData() {
      this.indicator = this.getIndicatorDataConsolidated(
        this.pillarId,
        this.indicatorId
      );
      if (this.indicator) {
        this.charts = this.indicator.chart;
      }
    },
  },
  computed: mapGetters(["getIndicatorDataConsolidated"]),
  mounted() {
    this.updateData();
  },
};
</script>
